import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import StatementsTable from "../../components/statements/StatementsTable/StatementsTable";
import { fetchBatchStatusDictionary } from "../../store/slices/dicts";
import { fetchStatements } from "../../store/slices/statements";

const StatementsTableContainer = ({
  defaultSearchValues,
  statementsSearchParams,
  setStatementsSearchParams,
}) => {
  const dispatch = useDispatch();

  const handleSearchStatements = ({ page, initialSearch = false }) => {
    const searchValues = initialSearch ? defaultSearchValues : statementsSearchParams;
    const searchParams = {
      page,
      includeBatchStatusIds: searchValues.includeBatchStatusIds,
    };
    if (searchValues.period) {
      searchParams.batchDateFrom = searchValues.period[0].format("YYYY-MM-DD");
      searchParams.batchDateTo = searchValues.period[1].format("YYYY-MM-DD");
    }
    if (searchValues.batchIds) {
      searchParams.batchIds = searchValues.batchIds.split(/\D/).filter(Boolean);
    }
    dispatch(fetchStatements(searchParams));
  };

  // Загрузка справочника статусов платежей
  useEffect(() => {
    dispatch(fetchBatchStatusDictionary());
  }, []);

  // Дефолтная загрузка выписки
  useEffect(() => {
    handleSearchStatements({ page: 0, ...statementsSearchParams });
  }, []);

  return (
    <StatementsTable
      initialSearchValues={statementsSearchParams}
      defaultSearchValues={defaultSearchValues}
      handleSearchStatements={handleSearchStatements}
      setStatementsSearchParams={setStatementsSearchParams}
    />
  );
};

export default StatementsTableContainer;
